import { render } from "./as-read-write.vue?vue&type=template&id=55550478&ts=true"
import script from "./as-read-write.vue?vue&type=script&lang=ts"
export * from "./as-read-write.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\src\\WebUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__